var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66634 2.9987V0.998698C3.66634 0.821887 3.73658 0.652318 3.8616 0.527293C3.98663 0.402269 4.1562 0.332031 4.33301 0.332031H9.66634C9.84315 0.332031 10.0127 0.402269 10.1377 0.527293C10.2628 0.652318 10.333 0.821887 10.333 0.998698V2.9987H13.6663V4.33203H12.333V12.9987C12.333 13.1755 12.2628 13.3451 12.1377 13.4701C12.0127 13.5951 11.8432 13.6654 11.6663 13.6654H2.33301C2.1562 13.6654 1.98663 13.5951 1.8616 13.4701C1.73658 13.3451 1.66634 13.1755 1.66634 12.9987V4.33203H0.333008V2.9987H3.66634ZM7.94234 8.33203L9.12101 7.15336L8.17834 6.2107L6.99967 7.38936L5.82101 6.2107L4.87834 7.15336L6.05701 8.33203L4.87834 9.5107L5.82101 10.4534L6.99967 9.2747L8.17834 10.4534L9.12101 9.5107L7.94234 8.33203ZM4.99967 1.66536V2.9987H8.99967V1.66536H4.99967Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b4114bcc5439c19d59defdec3ec8b041.svg";
export { ForwardRef as ReactComponent };